import { render } from "./staff_logs.vue?vue&type=template&id=31901376"
import script from "./staff_logs.vue?vue&type=script&lang=js"
export * from "./staff_logs.vue?vue&type=script&lang=js"

import "./staff_logs.vue?vue&type=style&index=0&id=31901376&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__